import axios from 'axios'

var corpusVersion = 4

export default {
    // async loadCountry () {
    //     // console.log('Loading country...')
    //     if(localStorage.ctflCountry) {
    //         return JSON.parse(localStorage.ctflCountry)
    //     }
    //     else {
    //         let response = await axios.get('data/country.json')
    //         localStorage.ctflCountry = JSON.stringify(response['data'])
    //         return response['data']
    //     }
    // },
    async loadCorpus () {
        // console.log('Loading corpus...')
        let ctflVersion = localStorage.getItem('ctflVersion')
        let ctflCorpus = localStorage.getItem('ctflCorpus')
        // if(ctflCorpus !== null) {
        // }
        if(ctflCorpus === null || ctflVersion < corpusVersion || ctflVersion === null) {
            let response = await axios.get('data/all.json')
            localStorage.ctflCorpus = JSON.stringify(response['data'])
            localStorage.ctflVersion = corpusVersion
            return response['data']
        }
        else {
            return JSON.parse(localStorage.ctflCorpus)
        }
    }
}